/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useState } from 'react';
import { colors } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';

import { BlIcon } from '@blend/shared-react';
import { ConfirmationModal } from '../../../components/common/Modals/ConfirmationModal/ConfirmationModal';

const styles = StyleSheet.create({
  backButtonIcon: {
    fontWeight: 500,
    display: 'inline-block',
    transform: 'rotate(90deg)',
  },
  backButton: {
    color: colors.reflex,
    cursor: 'pointer',
    display: 'inline',
  },
  backButtonText: {
    fontSize: 16,
    marginLeft: 5,
    fontWeight: 500,
  },
});

export const BackButton: React.FC<{
  goBack: () => void;
}> = ({ goBack }) => {
  const heading = 'Select a different user?';
  const contentLabel = 'Back to user selection confirmation';
  const confirmButtonText = 'Yes';
  const closeButtonText = 'No, continue validation';

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const closeModalGoBack = () => {
    setConfirmationOpen(false);
    goBack();
  };
  const closeModal = () => setConfirmationOpen(false);
  return (
    <>
      <div className={css(styles.backButton)} onClick={() => setConfirmationOpen(true)}>
        <span className={css(styles.backButtonIcon)}>
          <BlIcon size="md" icon={'caret-2'} />
        </span>
        <span className={css(styles.backButtonText)}>Back</span>
      </div>
      <ConfirmationModal
        contentLabel={contentLabel}
        isOpen={confirmationOpen}
        handleClose={closeModal}
        handleConfirm={closeModalGoBack}
        heading={heading}
        confirmButtonText={confirmButtonText}
        closeButtonText={closeButtonText}
      />
    </>
  );
};
